import type { ReactNode } from 'react';
import { Button } from '@mui/material';
import classNames from 'classnames';

import { LocationAutocomplete } from '@/components/LocationAutocomplete';
import type { LocationModel } from '@/types/location';
import { RentPeriodEnum, TransactionTypeEnum } from '@/types';

import styles from './AdsFilters.module.scss';
import { ReactComponent as HotIcon } from './hot.svg';

interface SearchModeOption {
  label: string;
  value: RentPeriodEnum | TransactionTypeEnum;
}

interface PrimarySearchRowProps {
  inputAddressValue: string;
  isRent?: boolean;
  locations: LocationModel[];
  onInputAddressChange: (value: string) => void;
  onInputAddressClear: () => void;
  onLocationSelect: (value: LocationModel) => void;
  onRentFrequencyChange: (value: RentPeriodEnum) => void;
  onTransactionTypeChange: (value: TransactionTypeEnum) => void;
  options: SearchModeOption[];
  propertyKind: ReactNode;
  rentFrequency: RentPeriodEnum | undefined;
  selectedLocation: LocationModel | null;
  setInputAddressValue: (value: string) => void;
  transactionType: TransactionTypeEnum[];
}

export const PrimarySearchRow = ({
  inputAddressValue,
  isRent,
  locations,
  onInputAddressChange,
  onInputAddressClear,
  onLocationSelect,
  onRentFrequencyChange,
  onTransactionTypeChange,
  options,
  propertyKind,
  rentFrequency,
  selectedLocation,
  setInputAddressValue,
  transactionType,
}: PrimarySearchRowProps) => (
  <div className={styles.primarySearchGrid} data-testid='primary-search-row'>
    <div className={styles.modeControl}>
      <div className={styles.frequencyContent}>
        {options.map(({ label, value }) =>
          isRent ? (
            <Button
              key={value}
              className={classNames(styles.itemButton, {
                [styles.active]: rentFrequency?.toString() === value.toString(),
              })}
              onClick={() => onRentFrequencyChange(value as RentPeriodEnum)}
              variant='contained'
            >
              {label}
            </Button>
          ) : (
            <Button
              key={value}
              className={classNames(styles.itemButton, {
                [styles.active]: transactionType.includes(value as TransactionTypeEnum),
              })}
              endIcon={value === TransactionTypeEnum.Distress ? <HotIcon /> : null}
              onClick={() => onTransactionTypeChange(value as TransactionTypeEnum)}
              variant='contained'
            >
              {label}
            </Button>
          )
        )}
      </div>
    </div>
    {propertyKind}
    <div className={styles.addressControl}>
      <LocationAutocomplete
        setInputAddressValue={setInputAddressValue}
        locations={locations}
        selectedLocation={selectedLocation}
        inputAddressValue={inputAddressValue}
        onInputChange={onInputAddressChange}
        handleClear={onInputAddressClear}
        onSelect={onLocationSelect}
      />
    </div>
  </div>
);
